const map = {
	"./avbryt_button_controller.js": 4425,
	"./charbox_size_controller.js": 7093,
	"./currentword_size_controller.js": 8441,
	"./fish_controller.js": 5178,
	"./game_controller.js": 5718,
	"./game_input_controller.js": 7455,
	"./glosepus_controller.js": 4419,
	"./highscore_controller.js": 3560,
	"./keyboard_controller.js": 2899,
	"./language_controller.js": 2983,
	"./modal_delete_controller.js": 291,
	"./modal_error_controller.js": 2908,
	"./modal_warning_controller.js": 3894,
	"./peek_answer_controller.js": 9350,
	"./qrcode_controller.js": 6179,
	"./reset_score_controller.js": 9538,
	"./share_controller.js": 9937,
	"./share_name_controller.js": 3793,
	"./show_share_controller.js": 7039,
	"./start_button_controller.js": 987,
	"./table_controller.js": 7688,
	"./tilbake_button_controller.js": 8947,
	"./timer_controller.js": 3119,
	"./toggle_controller.js": 4511,
	"./try_again_controller.js": 4134
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 860;